<template>
    <div class="alternative-day" :class="{ 'placeholder alternative-day--placeholder': placeholder, 'no-availability': times && !availableTimes.length }">
        <template v-if="!placeholder">
            <div class="alternative-day__header">
                <strong>{{ header }}</strong>
                <a v-if="availableTimes.length" href="#" v-on:click="seeAvailabilityFor(day.date)">See More &gt;</a>
                <span v-if="!availableTimes.length" class="alternative-day__no-availability">No availability</span>
            </div>
            <div class="alternative-day__buttons" v-if="availableTimes.length">
                <button class="button" v-for="time in availableTimes" v-bind:key="time.uniqueId" v-on:click="makeAlternativeSelection(day.date, time)">
                    <strong>{{ DateService.friendlyTime(time.time) }}</strong>
                    <div class="alternative-day--instant" v-if="time.isInstant">
                        <small>
                            <svg width="10" height="10" viewBox="0 0 1792 1792" title="Instant Book available">
                                <path d="M1333 566q18 20 7 44l-540 1157q-13 25-42 25-4 0-14-2-17-5-25.5-19t-4.5-30l197-808-406 101q-4 1-12 1-18 0-31-11-18-15-13-39l201-825q4-14 16-23t28-9h328q19 0 32 12.5t13 29.5q0 8-5 18l-171 463 396-98q8-2 12-2 19 0 34 15z"/>
                            </svg> avail.
                        </small>
                    </div>
                    <small v-else>Enquire</small>
                </button>

            </div>
        </template>
        <template v-if="placeholder">
            <div class="alternative-day__cover alternative-day__cover-1"></div>
            <div class="alternative-day__cover alternative-day__cover-2"></div>
            <div class="alternative-day__cover alternative-day__cover-3"></div>
            <div class="alternative-day__cover alternative-day__cover-4"></div>
            <div class="alternative-day__cover alternative-day__cover-5"></div>
            <div class="alternative-day__cover alternative-day__cover-6"></div>
            <div class="alternative-day__cover alternative-day__cover-7"></div>
            <div class="alternative-day__cover alternative-day__cover-8"></div>
            <div class="alternative-day__cover alternative-day__cover-9"></div>
            <div class="alternative-day__cover alternative-day__cover-10"></div>
        </template>
    </div>
</template>

<script>
  import DateService from '../services/DateService'

  export default {
    name: 'altSlot',
    props: [
      'day',
      'header',
      'seeMoreAction',
      'times',
      'noTimesTxt',
      'placeholder'
    ],
    data () {
      return {
        DateService,
        noTimesMsg: 'No availability'
      }
    },
    methods: {
      seeAvailabilityFor (date) {
        this.$emit('seeMore', date)
        // return this.$parent.seeAvailabilityFor(date)
      },
      makeAlternativeSelection (date, time) {
        this.$emit('selectTime', date, time)
        // return this.$parent.makeAlternativeSelection(date, time)
      }
    },
    mounted () {
    },
    computed: {
      availableTimes: function () {
        return this.times.filter(time => time.isBookable)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// altSlot.vue?326c6a71